/* JUSTYOL — in-app cart freshness stopgap.
   The Android app's WebView uses cacheMode LOAD_CACHE_ELSE_NETWORK, which
   serves stale cached copies of /cart and /cart?view=checkout — the cart
   flickers between old snapshots (wrong items/totals). The real fix is a
   one-line app change (cacheMode: LOAD_DEFAULT); until that release ships,
   this makes the cart always load fresh IN THE APP ONLY:
     1) cache-bust every cart navigation link at click time (bottom-nav
        Panier, drawer CTA, sticky bars, "voir le panier") — a unique URL is
        a guaranteed cache miss, so the WebView must fetch from the network.
     2) self-heal a cart view reached without a bust (back button / direct):
        fetch the true cart and reload once only if the rendered cart is stale.
   No-op on the web (only runs when JY_IS_APP). */
(function () {
  'use strict';
  if (window.JY_IS_APP !== true) return;

  function ts() {
    return Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36);
  }
  /* matches /cart, /cart?, /cart#, /ar/cart… but not /cart/add|change|update|clear */
  var CART_RE = /(^|\/)cart(\/|\?|#|$)/i;
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)/i;

  function bust(href) {
    try {
      var u = new URL(href, location.origin);
      u.searchParams.set('_jync', ts());
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return href;
    }
  }

  /* 1) cache-bust cart links at click time (capture phase, before navigation) */
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!CART_RE.test(href) || CART_WRITE_RE.test(href)) return;
      a.setAttribute('href', bust(href));
    },
    true
  );

  /* 2) self-heal a stale cart view */
  function selfHeal() {
    var root = document.querySelector('[data-jy-cart-count]');
    if (!root) return;
    if (/[?&]_jync=/.test(location.search)) return; /* already loaded fresh */
    var rendered = parseInt(root.getAttribute('data-jy-cart-count'), 10);
    if (isNaN(rendered)) return;
    fetch('/cart.js?_jync=' + ts(), { headers: { Accept: 'application/json' }, cache: 'reload' })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        if (c && typeof c.item_count === 'number' && c.item_count !== rendered) {
          location.replace(bust(location.href));
        }
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selfHeal);
  else selfHeal();
})();
